import { FC } from 'react';
import ListCaseStudies from 'modules/users/modules/profiles/components/ListCaseStudies';
import styles from './ProCaseStudyContent.module.scss';

interface Props {
  base: string;
  jobType?: string;
  prefix: string;
  profileCaseStudyUrl: string;
}

const ProCaseStudyContent: FC<Props> = ({ base, jobType, prefix, profileCaseStudyUrl }) => {
  const listCaseStudiesProps = { base, prefix };

  return (
    <section id="case-study-in-pro-profile" className={styles['pro-profile-case-study']}>
      <ListCaseStudies
        jobType={jobType}
        title={listCaseStudiesProps}
        profileCaseStudyUrl={profileCaseStudyUrl}
      />
    </section>
  );
};

export default ProCaseStudyContent;
